import { CardBackground, Tooltip } from 'components/ui';
import { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useUpdateOnboardingSettingsMutation } from 'store/services/segmentsApi';
import { useParseURLQueryParams } from 'utils';
import { objectivesList } from './descriptions';
import { StepsLayout } from './StepsLayout';
import { useOnboardingState } from './useOnboardingState';

export const RecommendedSegmentsStep = () => {
  const {
    objectives,
    segmentsMatchingObjectives,

    setSegments,
    segments,
    localStorageKey,
  } = useOnboardingState();

  const { rawQueryParams } = useParseURLQueryParams();
  const queryParams = `store_name=${rawQueryParams?.store_name}`;

  const [updateOnboardingSettings] = useUpdateOnboardingSettingsMutation();

  const history = useHistory();

  const handleOnNext = () => {
    const savedProgress = localStorage.getItem(localStorageKey);

    localStorage.setItem(
      localStorageKey,
      JSON.stringify({
        ...(savedProgress ? JSON.parse(savedProgress) : {}),
        segments,
      })
    );

    updateOnboardingSettings({
      serializedStoreName: queryParams,
      body: {
        segment_names: segments,
      },
    });
    history.push({
      ...history.location,
      pathname: '/onboarding/integrations',
    });
  };

  useEffect(() => {
    const currentOnboarding = localStorage.getItem(localStorageKey);

    if (currentOnboarding) {
      const { segments } = JSON.parse(currentOnboarding);

      if (segments?.length) {
        setSegments(segments);
      } else {
        setSegments(segmentsMatchingObjectives.slice(0, 3));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <StepsLayout>
      <div className="mt-4 lg:mt-10 lg:grid lg:grid-cols-8 lg:gap-x-9">
        <div className="col-span-3">
          <div className="px-2.5 lg:px-0">
            <p className="text-black text-opacity-30">3/4</p>
            <p className="mt-4 font-bold leading-8 text-segments-32px">
              Recommended high impact segments
            </p>

            <div className="mt-4">
              <p>
                Based on your business goals, we recommend syncing these
                segments. You can select your preferred segments, and we will
                place them on top of the segment list.
              </p>
            </div>
          </div>
          <div className="mt-8">
            <div>
              <p className="font-bold">Business objectives</p>
              <ul className="mt-3 space-y-2 list-disc list-inside">
                {objectives.length ? (
                  objectives.map((objective, index) => (
                    <li key={index}>
                      {
                        objectivesList.find((item) => item.value === objective)
                          ?.label
                      }
                    </li>
                  ))
                ) : (
                  <li>No objectives selected</li>
                )}
              </ul>
            </div>
          </div>
        </div>
        <div className="col-span-5 mt-10 lg:mt-0">
          <CardBackground>
            <div className="p-10">
              <p className="font-bold">Select your favorite segments</p>
              <div className="grid grid-cols-2 gap-3 mt-10 xl:grid-cols-4">
                {segmentsMatchingObjectives.map((segment, index) => (
                  <CardBox key={index} value={segment} />
                ))}
              </div>
            </div>
          </CardBackground>
        </div>
      </div>

      <div className="flex items-center justify-center my-10 space-x-8 ">
        <Link
          to={{
            ...history.location,
            pathname: '/onboarding/objectives',
          }}
          className="py-3 font-bold text-black text-opacity-50 lg:px-14 rounded-xl "
        >
          Previous
        </Link>
        <button
          onClick={handleOnNext}
          className="py-3 font-bold text-white border px-14 lg:px-20 rounded-xl bg-segments-accent-color-1 border-segments-accent-color-1"
        >
          Next
        </button>
      </div>
    </StepsLayout>
  );
};

function CardBox({ value }: { value: string }) {
  const { getSegmentDescription, setSegments, segments } = useOnboardingState();

  const isCurrentSelected = segments.includes(value);

  const handleToggle = () => {
    if (isCurrentSelected) {
      setSegments(segments.filter((segment) => segment !== value));
    } else {
      setSegments([...segments, value]);
    }
  };
  return (
    <button
      className={` w-full h-[130px] bg-segments-gray-F8 p-2 shadow-md rounded-3xl disabled:cursor-not-allowed disabled:opacity-50 ${
        isCurrentSelected &&
        'border-segments-link text-segments-link bg-segments-accent-green-3 border-2 font-bold'
      }`}
      onClick={handleToggle}
    >
      <Tooltip text={getSegmentDescription(value)}>
        <p>{value}</p>
      </Tooltip>
    </button>
  );
}
